import { Plugin as ProseMirrorPlugin, PluginKey as ProseMirrorPluginKey, } from 'prosemirror-state';
const baseConfig = {
    debounce: 0,
};
export function createProseMirrorPluginByDecorate(editor, name, decorate) {
    const normalizeDecorateConfig = typeof decorate === 'function'
        ? {
            ...baseConfig,
            decorate,
        }
        : { ...baseConfig, ...decorate };
    const debounceMetaName = `ex.${name}:internal-debounce-meta`;
    let debounceTimer = null;
    let docChangedWhileDebouncing = false;
    return new ProseMirrorPlugin({
        key: new ProseMirrorPluginKey(`ex.${name}.auto-created-decorate`),
        state: {
            init(_, state) {
                const result = normalizeDecorateConfig.decorate(state.doc, true);
                return result === false ? null : result;
            },
            apply(tr, old) {
                var _a;
                if (tr.getMeta("ex:skipDecos" /* ExTrMetaKeys.skipDecos */) === true) {
                    return old;
                }
                // 默认的返回，也是 decorate 计算为 false 时的返回值
                const defaultRet = (_a = old === null || old === void 0 ? void 0 : old.map(tr.mapping, tr.doc)) !== null && _a !== void 0 ? _a : null;
                const targetPlugin = tr.getMeta("ex:targetPlugin" /* ExTrMetaKeys.targetPlugin */);
                const isTargetingSomePlugin = !!targetPlugin;
                // 如果 tr 指定了只针对某一个插件，则其他插件直接返回默认值
                if (isTargetingSomePlugin && targetPlugin !== name) {
                    return defaultRet;
                }
                // debounce 逻辑：如果开启了 debounce 但 tr 没有标记，
                // 则重新定时一个带标记的 refresh
                const isDebounceEnabled = normalizeDecorateConfig.debounce > 0;
                const hitDebounceWall = isDebounceEnabled &&
                    !tr.getMeta(debounceMetaName) &&
                    !(isTargetingSomePlugin && tr.getMeta("ex:targetPluginForce" /* ExTrMetaKeys.targetPluginForce */));
                if (hitDebounceWall) {
                    docChangedWhileDebouncing || (docChangedWhileDebouncing = tr.docChanged);
                    if (debounceTimer) {
                        clearTimeout(debounceTimer);
                    }
                    debounceTimer = window.setTimeout(() => {
                        debounceTimer = null;
                        if (!editor.isDestroyed) {
                            editor.refreshPlugin(name, debounceMetaName);
                        }
                    }, normalizeDecorateConfig.debounce);
                    return defaultRet;
                }
                const docChanged = isDebounceEnabled
                    ? docChangedWhileDebouncing
                    : tr.docChanged;
                docChangedWhileDebouncing = false;
                const ret = normalizeDecorateConfig.decorate(tr.doc, docChanged, tr);
                return ret === false ? defaultRet : ret;
            },
        },
        props: {
            decorations(state) {
                return this.getState(state);
            },
        },
    });
}
//# sourceMappingURL=decorate.js.map